import React from "react"
import {useTranslation} from "react-i18next"

import {IonItem, IonLabel, IonList} from "@ionic/react"

import TimeLimit     from "@customTypes/TimeLimit"
import TimeLimitData from "@customTypes/TimeLimitData"

import ItemSegmentListHeader from "../common/Headers/ItemSegmentListHeader"
import IconTimeLimitData from "../common/Icons/TImeLimitData";

interface componentProps {
    item: TimeLimit | undefined;
}

const TimeLimitDataList: React.FC<componentProps> = ({ item }) => {

    const { t } = useTranslation()

    const title:  string = item?.name || ''
    const subTitle: string = item?.description ? item?.description : ''

    let right: string = item?.startDate && item?.endDate ? item.startDate + ' - ' + item.endDate : ''

    if (item?.startDate && ! item?.endDate) {
        right = t('time-limits.form.start_date') + ': ' + item?.startDate
    } else if (item?.endDate && ! item?.startDate) {
        right = t('time-limits.form.start_date') + ': ' + item?.endDate
    }

    const weekDays: string[] = [
        'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday',
    ];

    return (
        <IonList lines="full">
            <ItemSegmentListHeader title={title} subTitle={subTitle} right={right} />
            {item?.timeLimitData === undefined || item.timeLimitData?.length === 0 ? (
                <IonItem className="ion-text-center" lines="inset">
                    <IonLabel className="ion-text-wrap">
                        {t('time-limits.no_time_limit_data')}
                    </IonLabel>
                </IonItem>
            ) : (
                item.timeLimitData?.map( (timeLimitDataItem: TimeLimitData, timeLimitDataItemIndex: number) => {

                    const itemWeekDays = weekDays.filter(
                        (weekDay: string) => {
                            return timeLimitDataItem['weekDay' + weekDay as keyof TimeLimitData] as boolean
                        }).map(weekDay => t('common.weekDays.' + weekDay).substring(0, 2))

                    return (
                        <IonItem key={'time-limit-data-' + timeLimitDataItem.id} lines="inset">
                            <IconTimeLimitData slot="start" />
                            <IonLabel>
                                <h2>
                                    {timeLimitDataItem.startTime} - {timeLimitDataItem.endTime}
                                </h2>
                                <h3 style={{ 'color': "#777" }}>
                                    {itemWeekDays.join(', ')}
                                </h3>
                            </IonLabel>
                        </IonItem>
                    )
                }))}
        </IonList>
    )
}

export default TimeLimitDataList